import React, { useMemo } from 'react';
import { S7SubCategories, ImageItem } from '@milanlaser/mlcomponents';
import { processBackgroundAndGradientColorMap, processBackgroundColor, useImageKey } from '../../utils/builder.utils';
import { PaddingSize, paddingMap } from '../../utils/builderPaddingOptions';

type S7SubCategoriesArgs = React.ComponentProps<typeof S7SubCategories> & {
    desktopPaddingTop?: PaddingSize;
    desktopPaddingBottom?: PaddingSize;
    mobilePaddingTop?: PaddingSize;
    mobilePaddingBottom?: PaddingSize;
};

interface ImageSet extends ImageItem {
    imageAltText: string;
}

export function S7SubCategoriesSection(S7SubCategoriesProps: S7SubCategoriesArgs) {
    const {
        desktopPaddingTop = 'large',
        desktopPaddingBottom = 'large',
        mobilePaddingTop = 'small',
        mobilePaddingBottom = 'small',
        images,
        ...restProps
    } = S7SubCategoriesProps;

    const topPaddingClasses = `mcl-pt-${paddingMap[mobilePaddingTop]} lg:mcl-pt-${paddingMap[desktopPaddingTop]}`;
    const bottomPaddingClasses = `mcl-pb-${paddingMap[mobilePaddingBottom]} lg:mcl-pb-${paddingMap[desktopPaddingBottom]}`;

    const imageSet = images?.map((pair: ImageSet) => ({
        ...pair,
        imageAltText: pair.imageAltText,
    }));

    const modifiedProps = {
        ...restProps,
        backgroundGradient: processBackgroundColor({
            backgroundGradient: S7SubCategoriesProps.backgroundGradient,
        }),
        backgroundColor: processBackgroundColor({
            backgroundColor: S7SubCategoriesProps.backgroundColor,
        }),
        className: `mcl-mx-auto mcl-max-w-7xl ${topPaddingClasses} ${bottomPaddingClasses}`,
    };

    const newKeyOnImageChange = useMemo(() => useImageKey(S7SubCategoriesProps.images), [S7SubCategoriesProps.images]);

    const backgroundColor = processBackgroundAndGradientColorMap({
        backgroundColor: S7SubCategoriesProps.backgroundColor || 'default',
        gradientColor: S7SubCategoriesProps.backgroundGradient || 'default',
    });

    return (
        <div className={`${backgroundColor}`}>
            <S7SubCategories
                key={newKeyOnImageChange}
                {...modifiedProps}
                images={imageSet}
                backgroundGradient="default"
            />
        </div>
    );
}
